<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import Vue from 'vue';
    import wechat from "@/assets/js/wechat";

    export default {
        name: 'App',
        created(){
            Vue.prototype.$wechat = wechat;

        },
        mounted(){
            // Vue.prototype.$wechat.share(null, false);
        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>